import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import StickyTable from "../../components/common/StickyTable";
import {
  ONE_TO_ONE_LIST,
  ONE_TO_ONE_DELETE,
  USER_LIST_DROPDOWN,
  COUNTRY_LIST_DROPDOWN,
  STATE_LIST_DROPDOWN,
  CHAPTER_LIST_DROPDOWN,
  REGION_LIST_DROPDOWN,
} from "../../routes/routes";
import { PAGINATE, NOPAGINATE, FBM_DELETED } from "../../constant/constant";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
  hasRole,
} from "../../components/Utils";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Modal } from "react-bootstrap";
import ModalImage from "react-modal-image";
import Select from "react-select";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_red.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { styleExcelHeaderRow } from "../../utils/excelStyles";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { usePermission } from "../../hooks/usePermission";
import { glassSelectStyles } from "../../constant/selectStyles";

const OnetoOneList = () => {
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [loading, setLoading] = useState(true);
  const [detailsModal, setDetailModal] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [filter, setFilter] = useState([]);
  const [userOptions, setUserOptions] = useState({});
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [showClearBtn, setShowClearBtn] = useState(false);
  const [btnExcelDisabled, setBtnExcelDisabled] = useState(false);
  const refFlatpickr = useRef(null);
  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);

  const handleStateClear = () => {
    selectStateRef.current.clearValue();
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleRegionClear = () => {
    selectRegionRef.current.clearValue();
    selectChapterRef.current.clearValue();
  };

  const handleChapterClear = () => {
    selectChapterRef.current.clearValue();
  };

  const { hasPermission } = usePermission();
  const navigate = useNavigate();
  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;

  const HandleDelete = async (fbmId) => {
    try {
      axios.delete(ONE_TO_ONE_DELETE + fbmId).then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(FBM_DELETED);
          setRefresh((prev) => !prev);
          navigate("/one-to-one");
        }
      });
    } catch (error) {
      console.error("Error deleting 121s:", error);
    }
  };

  //excel export start
  const columns = [{ header: "Sl.No.", key: "sno" }];
  if (hasRole([1])) {
    columns.push({ header: "Country", key: "country_name" });
  }
  if (hasRole([1, 6])) {
    columns.push({ header: "State", key: "state_name" });
  }
  if (hasRole([1, 6, 7])) {
    columns.push({ header: "Region", key: "region_name" });
  }
  if (hasRole([1, 6, 7, 2])) {
    columns.push({ header: "Chapter", key: "chapter_name" });
  }
  columns.push(
    { header: "From User Name", key: "from_user_name" },
    { header: "To User Name", key: "to_user_name" },
    { header: "Initiated By", key: "initiated_by_text" },
    { header: "Meet Location", key: "meet_location" },
    { header: "Date", key: "date" },
    { header: "Conversation", key: "conversation" },
    { header: "Entry Time", key: "created_at" },
  );

  const currentDate = moment().format("DD-MM-YYYY");
  //excel title starts
  const { from_date, to_date } = filter;
  let workSheetName = `121s`;
  if (from_date && to_date) {
    if (from_date === to_date) {
      workSheetName += ` (${moment(from_date).format("DD-MM-YYYY")})`; // single date
    } else {
      workSheetName += ` (${moment(from_date).format("DD-MM-YYYY")} to ${moment(to_date).format("DD-MM-YYYY")})`;
    }
  }
  //excel title end

  const workBookName = "121s List";

  const workbook = new Excel.Workbook();

  const exportAsExcel = async () => {
    try {
      const fileName = workBookName;
      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;
      // updated the font and fill for header row cells.
      const headerRow = worksheet.getRow(1);
      styleExcelHeaderRow(headerRow, columns.length);

      // loop through all of the columns and set the alignment with width.
      worksheet.columns.forEach((column) => {
        column.width = column.header.length + 15;
        column.alignment = { horizontal: "center" };
      });
      setBtnExcelDisabled(true);
      await axios
        .get(ONE_TO_ONE_LIST, {
          params: {
            paging_type: NOPAGINATE,
            isAdmin: 1,
            ...filter,
          },
        })
        .then(async (response) => {
          if (response.status === 200 && response.data.success) {
            const excelData = response.data.data.onetoone;

            if (excelData.length < 1) {
              toast.error("No data found!.");
              return;
            }

            // loop through data and add each one to worksheet
            excelData.forEach((singleData) => {
              worksheet.addRow(singleData);
            });

            // loop through all of the rows and set the outline style.
            worksheet.eachRow({ includeEmpty: false }, (row) => {
              // store each cell to currentCell
              const currentCell = row._cells;
              // loop through currentCell to apply border only for the non-empty cell of excel
              currentCell.forEach((singleCell) => {
                // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
                const cellAddress = singleCell._address;
                console.log(singleCell);
                // apply border
                worksheet.getCell(cellAddress).border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              });
            });

            // write the content using writeBuffer
            const buf = await workbook.xlsx.writeBuffer();
            // download the processed file
            saveAs(new Blob([buf]), `${fileName}.xlsx`);
          }
        })
        .finally(() => {
          setBtnExcelDisabled(false);
        });
    } catch (error) {
      console.error("<<<ERRROR>>>", error);
      console.error("Something Went Wrong", error.message);
      toast.error(error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };
  //end

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    refFlatpickr.current.flatpickr.setDate([]);
    setFilter({
      ...filter,
      from_date: "",
      to_date: "",
    });
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(ONE_TO_ONE_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.onetoone);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch user data
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          },
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [page, filter, perPage, refresh]);

  const handleCalendarClick = () => {
    if (refFlatpickr.current) {
      refFlatpickr.current.flatpickr.open();
    }
  };
  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">121s</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>Dashboard</Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">121s</span>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              {hasPermission("fbms-list-export") && (
                <div className="pt-btn">
                  <button
                    disabled={btnExcelDisabled}
                    type="button"
                    onClick={exportAsExcel}
                    className="btn rounded-pill btn-primary excel-btn ibutton"
                  >
                    <span className="tf-icons bx bxs-spreadsheet"></span>&nbsp;
                    Excel
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="filter-card">
          <h6 className="filter-card-title">Search &amp; Filter</h6>

            <div className="row mb-4 gx-3">
              {hasRole([1]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <label className="filter-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      setFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <label className="filter-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      setFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              )}

              {hasRole([1, 6, 7]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mb-3">
                    <label className="filter-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      ref={selectRegionRef}
                      menuPortalTarget={document.body}
                      styles={glassSelectStyles}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        setFilter({
                          ...filter,
                          region_id: selected?.value,
                          chapter_id: null,
                        });
                      }}
                    />
                  </div>
                </div>
              )}

              {hasRole([1, 6, 7, 2]) && (
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mb-3">
                    <label className="filter-label" htmlFor="chapter_id">
                      Chapter
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={glassSelectStyles}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) =>
                        setFilter({ ...filter, chapter_id: selected?.value })
                      }
                    />
                  </div>
                </div>
              )}
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3">
                  <label className="filter-label" htmlFor="email">
                    From User
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    name="from_user"
                    isClearable
                    options={userOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, from_user: selected?.value })
                    }
                    placeholder="From User"
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3">
                  <label className="filter-label" htmlFor="email">
                    To User
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={glassSelectStyles}
                    name="to_user"
                    isClearable
                    options={userOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, to_user: selected?.value })
                    }
                    placeholder="To User"
                  />
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="filter-label" htmlFor="date_range">
                    Meeting Date Range
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <Flatpickr
                        ref={refFlatpickr}
                        className="form-control"
                        options={{
                          mode: "range",
                          dateFormat: "Y-m-d",
                          onChange: (selected) => {
                            setShowClearBtn(true);
                            if (
                              selected[0] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== undefined &&
                              selected[1] !== ""
                            ) {
                              setFilter({
                                ...filter,
                                from_date: selected[0]
                                  ? moment(selected[0]).format("YYYY-MM-DD")
                                  : "",
                                to_date: selected[1]
                                  ? moment(selected[1]).format("YYYY-MM-DD")
                                  : "",
                              });
                            }
                          },
                          onClose: (selected) => {
                            if (!selected[1]) {
                              setShowClearBtn(false);
                            }
                          },
                        }}
                        placeholder="Date Range"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
        </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}

        <div className="card icard sticky-table-card">
          {/* <div className="card-header">
            <h5>121s</h5>
          </div> */}
          
          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable sticky-action-col">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                  <th>From User</th>
                  <th>To User</th>
                  <th>Initiated by</th>
                  <th>Meet Location</th>
                  <th>Meeting Date</th>
                  <th>Entry Time</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="12" />
                ) : data.length > 0 ? (
                  data.map((onetoone, i) => (
                    <tr key={i}>
                      <td>{onetoone?.sno}</td>
                      {hasRole([1]) && <td>{onetoone?.country_name}</td>}
                      {hasRole([1, 6]) && <td>{onetoone?.state_name}</td>}
                      {hasRole([1, 6, 7]) && <td>{onetoone?.region_name}</td>}
                      {hasRole([1, 6, 7, 2]) && (
                        <td>{onetoone?.chapter_name}</td>
                      )}
                      <td>
                        <span className="table_img pr-2">
                          <img src={onetoone?.from_profile_image} alt="icon" />
                        </span>
                        {onetoone?.from_user_name}
                      </td>
                      <td>
                        <span className="table_img pr-2">
                          <img src={onetoone?.to_profile_image} alt="icon" />
                        </span>
                        {onetoone?.to_user_name}
                      </td>
                      <td>{onetoone?.initiated_by_text}</td>
                      <td>{onetoone?.meet_location}</td>
                      <td>{onetoone?.date}</td>
                      <td>{onetoone?.created_at}</td>
                      <td style={{ textAlign: "center" }}>
                        {hasPermission("fbms-list") && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="View"
                            data-bs-original-title="View"
                            onClick={() => {
                              setDetailModal(true);
                              setDetailData(onetoone);
                            }}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}
                        {hasPermission("fbms-edit") && (
                          <Link to={`/one-to-one/${onetoone.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}
                        {hasPermission("fbms-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message: "Are you sure, you want to delete?",
                                fn: () => HandleDelete(onetoone?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="12" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={detailsModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            121s Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.date)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">From User Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.from_user_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">To User Name</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.to_user_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Initiated By</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.initiated_by_text)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Meet Location</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.meet_location)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Conversation</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.conversation)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Image</label>

                  {detailData.image !== "" ? (
                    <span className="d-block font-weight-600">
                      <ModalImage
                        small={detailData.image}
                        large={detailData.image}
                        alt="121s Image"
                        showRotate
                        hideDownload={true}
                      />
                    </span>
                  ) : (
                    <span className="d-block font-weight-600">-</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#163586"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                setConfirmationModal(false);
                confirmation?.fn?.();
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OnetoOneList;
